import { apiService } from './api';

export type TaxonomyDomain =
  | 'stakeholder_category'
  | 'relationship_category'
  | 'organization_type'
  | 'influence_category'
  | 'issue_category';

export type TaxonomyItem = {
  id: string;
  domain: TaxonomyDomain;
  key: string;
  label: string;
  color?: string;
};

export async function listTaxonomies(domain: TaxonomyDomain) {
  const res = await apiService.get<TaxonomyItem[]>(`/api/taxonomies`, { params: { domain } });
  return res.data;
}

export async function createTaxonomy(payload: { domain: TaxonomyDomain; key?: string; label: string; color?: string }) {
  const res = await apiService.post<TaxonomyItem>(`/api/taxonomies`, payload);
  return res.data;
}

export async function updateTaxonomy(id: string, payload: Partial<{ domain: TaxonomyDomain; key: string; label: string; color: string }>) {
  const res = await apiService.patch<TaxonomyItem>(`/api/taxonomies/${id}`, payload);
  return res.data;
}

export async function deleteTaxonomy(id: string) {
  const res = await apiService.delete(`/api/taxonomies/${id}`);
  return res.data as { success: boolean };
}
